module.exports = __webpack_public_path__ + "static/img/sel.67ea96b.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/sel.png
// module id = D/Ia
// module chunks = 1